<template>
  <p class="big-title-container">
    <slot/>
  </p>
</template>

<script>
export default {
  name: "BigTitle"
}
</script>

<style scoped lang="scss">
.big-title-container {
  color: var(--color-white);
  font-weight: 500;
  font-size: 24px;

  &.dark-green{
    color: var(--color-dark-green);
  }
}
</style>